var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWithdrawalCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#FFB800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 33.75C27.7 33.75 27.5 32.675 27.5 32.5H25C25 33.65 25.825 35.6875 28.75 36.15V37.5H31.25V36.15C33.75 35.725 35 34.1125 35 32.5C35 31.1 34.35 28.75 30 28.75C27.5 28.75 27.5 27.9625 27.5 27.5C27.5 27.0375 28.375 26.25 30 26.25C31.625 26.25 31.7375 27.05 31.75 27.5H34.25C34.2331 26.6484 33.9268 25.828 33.3816 25.1737C32.8363 24.5194 32.0845 24.0702 31.25 23.9V22.5H28.75V23.8625C26.25 24.275 25 25.8875 25 27.5C25 28.9 25.65 31.25 30 31.25C32.5 31.25 32.5 32.1 32.5 32.5C32.5 32.9 31.725 33.75 30 33.75Z",
    fill: "#000015",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 17.5H17.5V20H20V41.25C20 41.5815 20.1317 41.8995 20.3661 42.1339C20.6005 42.3683 20.9185 42.5 21.25 42.5H38.75C39.0815 42.5 39.3995 42.3683 39.6339 42.1339C39.8683 41.8995 40 41.5815 40 41.25V20H42.5V17.5H21.25ZM37.5 40H22.5V20H37.5V40Z",
    fill: "#000015",
    fillOpacity: 0.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawalCard);
export default __webpack_public_path__ + "static/media/withdrawal-card.a928ca70b792387fd76281d6424d6094.svg";
export { ForwardRef as ReactComponent };